

/**
 * @fileoverview Connect an explicitly supplied measurement callback to optional browser-performance collection. The caller owns the sink and interpretation; no measurements are delivered without that callback. Performance samples are separate from operational audit, business outcomes, or error reports.
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(

    ({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
